import React, { useContext, useEffect, useState } from "react";
import { AffiliationTabs } from "features/affiliation/common/types";
import styled, { css } from "styled-components";
import AffiliationPageProvider from "features/affiliation/AffiliationPageProvider";
import useTabsWithUrl from "common/Tabs/useTabsWithUrl";
import { AFFILIATION_PATH } from "common/constants";
import { AnalyticsContext } from "analytics/AnalyticsProvider";
import AffiliationAgreementModal from "features/affiliation/AffiliationAgreementModal";
import { useSelector } from "react-redux";
import { sharedLib } from "@shared/services/shared.service";
import { useTabToDisplay } from "features/affiliation/common/hooks/misc.ts";
import {
  phoneMinWidth,
  NEW_LOOK_PAGE_GUTTER_VAR,
} from "common/NewLook/layout.ts";

const Affiliation = () => {
  const { analytics } = useContext(AnalyticsContext);
  const user = useSelector(sharedLib.selectors.authentication.selectUser);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const tabToDisplay = useTabToDisplay({});

  const {
    tab,
    tabDisplayName,
    onChange: onTabChange,
  } = useTabsWithUrl<AffiliationTabs>({
    tabToDisplayName: tabToDisplay,
    tabs: Object.values(AffiliationTabs),
    path: AFFILIATION_PATH,
    defaultTab: AffiliationTabs.OVERVIEW,
    keepQuery: false,
  });

  useEffect(() => {
    if (!user?.accepted_affiliation_terms) setConfirmModalOpen(true);
  }, [user]);

  useEffect(() => {
    if (tab === AffiliationTabs.REFERRAL_LINKS) {
      analytics?.affiliationReferralLinksView({});
    } else if (tab === AffiliationTabs.REFERRED_USERS) {
      analytics?.affiliationReferredUsersView({});
    } else if (tab === AffiliationTabs.EXISTING_USERS) {
      analytics?.affiliationExistingUsersView({});
    } else if (tab === AffiliationTabs.EARNINGS) {
      analytics?.affiliationEarningsView({});
    } else if (tab === AffiliationTabs.PAYOUTS) {
      analytics?.affiliationPayoutsView({});
    }
  }, [analytics, tab]);

  return (
    <Wrapper>
      <AffiliationPageProvider
        tab={tab}
        tabDisplayName={tabDisplayName}
        onTabChange={onTabChange}
      />
      <AffiliationAgreementModal
        visible={confirmModalOpen}
        closeModal={() => setConfirmModalOpen(false)}
      />
    </Wrapper>
  );
};

export default Affiliation;

const Wrapper = styled.div`
  height: 100%;
  @media (min-width: ${phoneMinWidth}) {
    padding: 16px;
    ${(p) =>
      p.theme.isNewLook &&
      css`
        padding: 16px ${NEW_LOOK_PAGE_GUTTER_VAR} 32px;
      `}
  }
`;
